<meta charset="UTF-8">
<app-system-message style="margin-left: 20vw;"></app-system-message>
<!-- Container -->
<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  @if (loading) {
    <app-loading-element class="loadingElementContainer componentBelow"></app-loading-element>
  }

  @if (this.dataLoaded) {
  <header class="mobileAlign2">
    <h2 class="mobile">{{"userlistTableHeaderDeviceList" | translate}} ({{this.filteredArray.length}})</h2>
  </header>
  }
  @if (this.dataLoaded) {
  <nav id="search-component" class="nav-sort-filter">
    <input
      #searchBox
      type="search"
      id="search-box"
      [(ngModel)]="userFilter"
      (input)="search()"
      class="form-control rounded searchInput"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    />
    <select
      class="form-control sort-by-select"
      [(ngModel)]="statusFilter"
      (change)="onStatusFilterChange()"
      [ngClass]="{ 'has-value': this.statusFilter }"
    >
      <option value="">{{ 'filterBy' | translate }}</option>
      @for (option of statusFilterOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <select
      class="form-control sort-by-select"
      [(ngModel)]="sortBy"
      (change)="onSortChange('select', $event)"
      [ngClass]="{ 'has-value': this.sortBy }"
    >
      <option value="">{{ 'sortBy' | translate }}</option>
      @for (option of sortOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>

    <div class="card-title status">
      <div class="mobileAlign">
        <label class="switch">
          <input type="checkbox" [ngModel]="this.ascDesc" (change)="onSortChange('switch', $event)">
          <span class="slider round">
              <span class="toggle-switch-label-off">{{ "desc" | translate }}</span>
              <span class="toggle-switch-label-on">{{ "asc" | translate }}</span>
          </span>
        </label>
      </div>
    </div>
  </nav>
  }


  <!-- Gridster Parent Container -->
  @if (this.dataLoaded) {
  <section class="gridThing" [ngClass]="theme.getThemeClass()">

    <!-- Navigation Items -->
    @for (thing of this.filteredArray; track thing.thing_name; let i = $index) {
      <!-- Tile -->
      <article  class=gridsterItemClientThing>
        <!-- Your tile content goes here -->
        <nav [ngClass]="theme.getThemeClass()" class="dashboardThing-tile">
          <header class="dashboard-tile-header">
            <!-- Light for device state -->
            <div class="mouseover-div"
            (mouseenter)="this.showStateInfo[i] = true"
            (mouseleave)="this.showStateInfo[i] = false"
            (touchstart)="showStateInfo[i] = true"
            (touchend)="showStateInfo[i] = false"
            >
              <div class="trafic-light-box">
                <div class="traffic-light">
                  <div class="light" [ngClass]="{
                    'light-green': thing.heartbeat && thing.heartbeat.color === 'green',
                    'light-yellow': thing.heartbeat && thing.heartbeat.color === 'yellow',
                    'light-red': thing.heartbeat && thing.heartbeat.color === 'red'
                    }">
                  </div>
                </div>
              </div>
              <h6 class="dashboardThing-tile-title">{{thing.thing_name | translate}}</h6>

              <!-- Info bubble on mouse over -->
              @if (showStateInfo[i]) {
              <div class="info-state-box" [ngClass]="theme.getThemeClass()">
                <div class="state-info-layer">
                  <label class="state-title">
                    {{ "beatMiss" | translate }} :
                  </label>
                  <label class="state-info">
                    @if (this.iotService.isBeatMissMoreThenOneHundred(thing.heartbeat?.beat_miss)) {
                      <span>+ </span>
                    }
                    {{ thing.heartbeat.beat_miss }}
                  </label>
                </div>
                <div class="state-info-layer">
                  <label class="state-title">
                    {{ "suposeToCommunicate" | translate }} :
                  </label>
                  <label class="state-info">
                    {{ thing.heartbeat.supposed_to_communicate}}
                  </label>
                </div>
                <div class="state-info-layer">
                  <label class="state-title">
                    {{ "sleepTimeConfig" | translate }} :
                  </label>
                  <label class="state-info">
                    {{ this.iotService.convertSecondToHour(thing.sleep_time) | translate }}
                  </label>
                </div>
              </div>
              }

            </div>

            @if (thing.battery > 100) {<i  class="fa-solid fa-plug-circle-bolt"></i>}
            <span class="dashboard-tile-action-container">

              <a class="nav-link e" href="javascript:void(0);" data-bs-toggle="dropdown">
                <i class="fa fa-bars"></i>
              </a>
              <ul [ngClass]="theme.getThemeClass()" class="dropdown-menu dropdown-menu-lg-end" >
                <!-- Menu Items -->
                  <li>
                    <a [ngClass]="theme.getThemeClass()" class="dropdown-item" style="cursor: pointer;" (click)="setNavToDeviceStat(thing.thing_name)" >
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'deviceStatistics' | translate }}
                      </span>
                    </a>
                  </li>
                  <li [ngClass]="{'closed': thing.bin_id === ''}">
                    <a (click)="routeToUpdateBin(thing.bin_id)" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1" [ngClass]="{'closed': thing.bin_id === ''}">
                        {{ 'viewBin' | translate }}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a (click)="exportCSV(thing)" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'exportCSV' | translate }}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a (click)="this.iotService.showConfig(thing.thing_name)" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'iotModalViewConfig' | translate }}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/work-order-create/{{thing.thing_name}}" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'createWorkOrder' | translate }}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a (click)="this.associateDevice(thing.thing_name, 'client')" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'clientAssociation' | translate }}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a (click)="this.associateDevice(thing.thing_name, 'bin')" [ngClass]="theme.getThemeClass()" class="dropdown-item" href="javascript:void(0)">
                      <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                      <span class="customMarginLeft1">
                        {{ 'binAssociation' | translate }}
                      </span>
                    </a>
                  </li>
              </ul>
            </span>
          </header>
          <hr>
          <div [ngClass]="theme.getThemeClass()" class="dashboardThing-tile-content" >
            <div class="marketLabel" >{{ thing.device.bin.bin_usage | translate }} {{ thing.device.bin.market_segment | translate }}</div>
            <div class="itemsDisplay">
              <div class="firstRow">
                <!-- HEALTHY -->
                <div class="itemsColum">
                  <div class="fa-3x">
                    @if (thing.status === 'Healthy') {<i class="fa-solid fa-heart-pulse greenC" [title]="'Healthy'"></i>}
                    @if (thing.status === 'Inactive') {<i class="fa-solid fa-heart-pulse grayC" [title]="'Inactive'"></i>}
                    @if (thing.status === undefined) {<i class="fa-solid fa-heart-pulse grayC" [title]="'Inactive'"></i>}
                    @if (thing.status === 'Unhealthy') {<i class="fa-solid fa-heart-pulse fa-fade redC" [title]="'Unhealthy'"></i>}
                  </div>
                  <div class="iconLabel">
                    {{ thing.status | translate }}
                  </div>
                </div>

                <!-- BATTERY -->
                <div class="itemsColum">
                  <div class="fa-3x">
                    @if (thing.status === 'Inactive') {<i class="fa-solid fa-battery-empty grayC"   [title]="'Inactive'"></i>}
                    @if (thing.battery > 3.5 && thing.status != 'Inactive') {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-full"  [title]="thing.battery + '%'"></i>}
                    @if (thing.battery <= 3.5 && thing.battery > 2.5 && thing.status != 'Inactive') {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-three-quarters"  [title]="thing.battery + '%'"></i>}
                    @if (thing.battery <= 2.5 && thing.battery > 1.5 && thing.status != 'Inactive') {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-half"  [title]="thing.battery + 'V'"></i>}
                    @if (thing.battery <= 1.5 && thing.battery > 0 && thing.status != 'Inactive') {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-quarter fa-fade"  [title]="thing.battery + '%'"></i>}
                    @if (thing.battery == 0 && thing.status != 'Inactive' ) {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-empty fa-fade" [title]="thing.battery + '%'"></i>}
                    @if (thing.battery == null || thing.battery == undefined) {<i [ngStyle]="getBatteryLevel(thing.battery)" class="fa-solid fa-battery-empty grayC"  [title]="'Inactive'"></i>}
                  </div>
                  @if (thing.battery >= 0 && thing.battery <= 100 && thing.status != 'Inactive') {
                    <div class="iconLabel">
                      {{ thing.battery  + '%' | translate }}
                    </div>
                  }
                  @if (thing.battery > 100 ) {
                    <div class="iconLabel">
                      {{ 'charging' | translate }}
                    </div>
                  }
                  @if ( thing.status === 'Inactive' ) {
                    <div class="iconLabel">
                      {{ 'Inactive' | translate }}
                    </div>
                  }
                </div>
                <!-- FILL LEVEL -->
                <div class="itemsColum">
                  <div class="fa-3x">
                    @if (thing.status === 'Healthy') {
                      <i [ngStyle]="getFillLevelStyle(thing.fill_level)" class="fa-solid fa-trash-can grayC" [title]="thing.fill_level"></i>
                    }
                    @if (thing.status === 'Unhealthy') {
                      <i [ngStyle]="getFillLevelStyle(thing.fill_level)" class="fa-solid fa-trash-can fa-fade grayC" [title]="thing.fill_level"></i>
                    }
                    @if (thing.status === 'Inactive' || thing.status === undefined) {
                      <i class="fa-solid fa-trash-can grayC" [title]="thing.fill_level"></i>
                    }
                  </div>
                  <div class="iconLabel">
                    {{ thing.fill_level | translate }}
                  </div>
                </div>
                <!-- TONNAGE -->
                <div class="itemsColum">
                  <div class="fa-3x">
                    <nav class="fadeIn first">
                      <img style="height: 35px; width: 35px;" class="logo" src="../assets/tonne-5123.webp" />
                    </nav>
                  </div>
                  <div class="iconLabel">
                    {{ thing.tonnage + ' T' }}
                  </div>
                </div>
              </div>
              <div class="secondRow">
                <div class="locationLabel">
                  <i class="fa-solid fa-map-pin locationLabel"></i>{{ thing.location }}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </article>
    }
    @if (this.filteredArray.length === 0 && this.originalArray.length != 0 ) {
      <article [ngClass]="theme.getThemeClass()" class="gridsterItemClientThing noDevice">
        <p>{{ 'noDevice' | translate}}</p>
        <!-- <h3><a href="javascript:void(0)" >Clear Filters</a></h3> -->
        <button [ngClass]="theme.getThemeClass()" class="btn clearFilters" (click)="clearFilters()">{{ 'clearFilter'|translate }}</button>
      </article>
    }
  </section>
  }

  <app-report-modal class="appDeviceConfigModal" [hidden]="!this.reports.showReportModal"></app-report-modal>



  </div>

  <!-- Graph Canvas for PDF Report -->
<div id="canvas-holder" class="canvasHolder">
  <canvas #tonnageCanvas class="displayNone"></canvas>
  <canvas #usageCanvas class="displayNone"></canvas>
  <canvas #marketCanvas class="displayNone"></canvas>
  <canvas #countCanvas class="displayNone"></canvas>
  <canvas #marketTonnageCanvas style="display: none;"></canvas>
  <canvas #usageTonnageCanvas style="display: none;"></canvas>
  <canvas #subgroupTonnageCanvas style="display: none;"></canvas>
</div>

  @if (this.iotService.showDeviceConfigModal) {
    <app-device-modal-config
      class="appDeviceConfigModal"
  ></app-device-modal-config>
  }

@if (this.relationModalService.showAssociationModal) {
  <app-distributor-iot-association-modal
    class="appAssociationModal"
    >
  </app-distributor-iot-association-modal>
}
<app-system-message></app-system-message>
